import React__default from 'react';

/**
 * Generates a random ID.
 * @returns {string} A random ID.
 */

var getRandomId = function getRandomId() {
  return "_".concat(Math.random().toString(36).substring(2, 9));
};

/**
 * Hook that provides a unique ID.
 * @returns {string} A unique ID.
 */
var useUniqueId = function useUniqueId() {
  /**
   * A reference to the local ID.
   * @type {React.MutableRefObject<string>}
   */
  var localId = React__default.useRef(getRandomId());
  return localId.current;
};

export { getRandomId, useUniqueId };
//# sourceMappingURL=useId.js.map
